//API
export const FETCH_START = 'fetch_start';
export const OPEN_FORM = 'open_form';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const TOGGLE_APP_DRAWER = 'toggle_app_drawer';
export const UPDATING_CONTENT = 'updating_content';
export const GET_COLECCION = 'get_coleccion';
export const CLOSE = 'close';
export const NO_CLOSE = 'no_close';
export const GET_COLECCION_ASOCIADO = 'get_coleccion_asociado';
export const GET_COLECCION_LIGERA_ASOCIADO = 'get_coleccion_ligera_asociado';
export const GET_COLECCION_DATOS_BASICOS_ASOCIADO =
  'get_coleccion_datos_basicos_ligera_asociado';
export const GET_COLECCION_LIGERA_ASOCIADO_CIUDAD =
  'get_coleccion_datos_basicos_ligera_asociado_ciudad';
export const GET_COLECCION_LIGERA_ASOCIADO_CIUDAD_OTRA =
  'get_coleccion_datos_basicos_ligera_asociado_ciudad_otra';
export const GET_COLECCION_LIGERA_ASOCIADO_ACTIVIDAD_ECONOMICA =
  'get_coleccion_datos_basicos_ligera_asociado_actividad_economica';
export const SHOW_ASOCIADO = 'show_asociado';
export const UPDATE_ASOCIADO = 'update_asociado';
export const CREATE_ASOCIADO = 'create_asociado';
export const DELETE_ASOCIADO = 'delete_asociado';
export const GET_CLAUSULAS = 'get_clausulas';
export const GET_TIPO_ROL = 'get_tipo_rol';
export const SHOW = 'show';
export const UPDATE = 'update';
export const CREATE = 'create';
export const DELETE = 'delete';
export const GET_COLECCION_USUARIO = 'get_coleccion_USUARIO';
export const GET_COLECCION_LIGERA_USUARIO = 'get_coleccion_ligera_usuario';
export const SHOW_USUARIO = 'show_usuario';
export const UPDATE_USUARIO = 'update_usuario';
export const CREATE_USUARIO = 'create_usuario';
export const DELETE_USUARIO = 'delete_usuario';
export const VERIFICAR_ASOCIADO = 'verificar_asociado';
export const GET_COLECCION_TIPO_DOCUMENTO = 'get_coleccion_tipo_documento';
export const GET_COLECCION_LIGERA_TIPO_DOCUMENTO =
  'get_coleccion_ligera_tipo_documento';
export const SHOW_TIPO_DOCUMENTO = 'show_tipo_documento';
export const UPDATE_TIPO_DOCUMENTO = 'update_tipo_documento';
export const CREATE_TIPO_DOCUMENTO = 'create_tipo_documento';
export const DELETE_TIPO_DOCUMENTO = 'delete_tipo_documento';
export const GET_COLECCION_ROL = 'get_coleccion_rol';
export const GET_COLECCION_LIGERA_ROL = 'get_coleccion_ligera_rol';
export const GET_PERMISOS = 'get_permisos';
export const OTORGAR_PERMISO = 'otorgar_permiso';
export const REVOCAR_PERMISO = 'revocar_permiso';
export const SHOW_ROL = 'show_rol';
export const UPDATE_ROL = 'update_rol';
export const CREATE_ROL = 'create_rol';
export const DELETE_ROL = 'delete_rol';
export const CREATE_TEMPLATE_ROL = 'create_template_rol';
export const GET_COLECCION_PAIS = 'get_coleccion_pais';
export const GET_COLECCION_LIGERA_PAIS = 'get_coleccion_ligera_pais';
export const SHOW_PAIS = 'show_pais';
export const UPDATE_PAIS = 'update_pais';
export const CREATE_PAIS = 'create_pais';
export const DELETE_PAIS = 'delete_pais';
export const GET_COLECCION_ACTIVIDAD_ECONOMICA =
  'get_coleccion_actividad_economica';
export const GET_COLECCION_LIGERA_ACTIVIDAD_ECONOMICA =
  'get_coleccion_ligera_actividad_economica';
export const SHOW_ACTIVIDAD_ECONOMICA = 'show_actividad_economica';
export const UPDATE_ACTIVIDAD_ECONOMICA = 'update_actividad_economica';
export const CREATE_ACTIVIDAD_ECONOMICA = 'create_actividad_economica';
export const DELETE_ACTIVIDAD_ECONOMICA = 'delete_actividad_economica';
export const GET_COLECCION_LISTA_DOCUMENTO = 'get_coleccion_LISTA_documento';
export const GET_COLECCION_LIGERA_LISTA_DOCUMENTO =
  'get_coleccion_ligera_LISTA_documento';
export const SHOW_LISTA_DOCUMENTO = 'show_LISTA_documento';
export const UPDATE_LISTA_DOCUMENTO = 'update_LISTA_documento';
export const CREATE_LISTA_DOCUMENTO = 'create_LISTA_documento';
export const DELETE_LISTA_DOCUMENTO = 'delete_LISTA_documento';
export const GET_COLECCION_REQUISITO_SEGURIDAD =
  'get_coleccion_requisito_seguridad';
export const GET_COLECCION_LIGERA_REQUISITO_SEGURIDAD =
  'get_coleccion_ligera_requisito_seguridad';
export const SHOW_REQUISITO_SEGURIDAD = 'show_requisito_seguridad';
export const UPDATE_REQUISITO_SEGURIDAD = 'update_requisito_seguridad';
export const CREATE_REQUISITO_SEGURIDAD = 'create_requisito_seguridad';
export const DELETE_REQUISITO_SEGURIDAD = 'delete_requisito_seguridad';
export const CLEAN_ROWS = 'clean_rows';
export const GET_COLECCION_PARAMETRO_CONSTANTE =
  'get_coleccion_parametro_constante';
export const GET_COLECCION_LIGERA_PARAMETRO_CONSTANTE =
  'get_coleccion_ligera_parametro_constante';
export const SHOW_PARAMETRO_CONSTANTE = 'show_parametro_constante';
export const UPDATE_PARAMETRO_CONSTANTE = 'update_parametro_constante';
export const CREATE_PARAMETRO_CONSTANTE = 'create_parametro_constante';
export const DELETE_PARAMETRO_CONSTANTE = 'delete_parametro_constante';
export const GET_COLECCION_DEPARTAMENTO = 'get_coleccion_departamento';
export const GET_COLECCION_LIGERA_DEPARTAMENTO =
  'get_coleccion_ligera_departamento';
export const SHOW_DEPARTAMENTO = 'show_departamento';
export const UPDATE_DEPARTAMENTO = 'update_departamento';
export const CREATE_DEPARTAMENTO = 'create_departamento';
export const DELETE_DEPARTAMENTO = 'delete_departamento';
export const GET_COLECCION_CIUDAD = 'get_coleccion_ciudad';
export const GET_COLECCION_LIGERA_CIUDAD = 'get_coleccion_ligera_ciudad';
export const SHOW_CIUDAD = 'show_ciudad';
export const UPDATE_CIUDAD = 'update_ciudad';
export const CREATE_CIUDAD = 'create_ciudad';
export const DELETE_CIUDAD = 'delete_ciudad';
export const GET_COLECCION_SERVICIO = 'get_coleccion_servicio';
export const GET_COLECCION_LIGERA_SERVICIO = 'get_coleccion_ligera_servicio';
export const SHOW_SERVICIO = 'show_servicio';
export const UPDATE_SERVICIO = 'update_servicio';
export const CREATE_SERVICIO = 'create_servicio';
export const DELETE_SERVICIO = 'delete_servicio';
export const GET_COLECCION_TERCERO_SERVICIO = 'get_coleccion_tercero_servicio';
export const GET_COLECCION_LIGERA_TERCERO_SERVICIO =
  'get_coleccion_ligera_tercero_servicio';
export const SHOW_TERCERO_SERVICIO = 'show_tercero_servicio';
export const UPDATE_TERCERO_SERVICIO = 'update_tercero_servicio';
export const CREATE_TERCERO_SERVICIO = 'create_tercero_servicio';
export const DELETE_TERCERO_SERVICIO = 'delete_tercero_servicio';
export const GET_COLECCION_EVENTO_NOTIFICACION =
  'get_coleccion_evento_notificacion';
export const GET_COLECCION_LIGERA_EVENTO_NOTIFICACION =
  'get_coleccion_ligera_evento_notificacion';
export const SHOW_EVENTO_NOTIFICACION = 'show_evento_notificacion';
export const UPDATE_EVENTO_NOTIFICACION = 'update_evento_notificacion';
export const CREATE_EVENTO_NOTIFICACION = 'create_evento_notificacion';
export const DELETE_EVENTO_NOTIFICACION = 'delete_evento_notificacion';
export const GET_COLECCION_PARAMETRO_CORREO = 'get_coleccion_parametro_correo';
export const GET_COLECCION_LIGERA_PARAMETRO_CORREO =
  'get_coleccion_ligera_parametro_correo';
export const SHOW_PARAMETRO_CORREO = 'show_parametro_correo';
export const UPDATE_PARAMETRO_CORREO = 'update_parametro_correo';
export const CREATE_PARAMETRO_CORREO = 'create_parametro_correo';
export const DELETE_PARAMETRO_CORREO = 'delete_parametro_correo';
export const GET_COLECCION_ASOCIADO_CONTACTO_LEGAL =
  'get_coleccion_asociado_contacto_legal';
export const SHOW_ASOCIADO_CONTACTO_LEGAL = 'show_asociado_contacto_legal';
export const UPDATE_ASOCIADO_CONTACTO_LEGAL = 'update_asociado_contacto_legal';
export const CREATE_ASOCIADO_CONTACTO_LEGAL = 'create_asociado_contacto_legal';
export const DELETE_ASOCIADO_CONTACTO_LEGAL = 'delete_asociado_contacto_legal';
export const GET_COLECCION_ASOCIADO_CONTACTO =
  'get_coleccion_asociado_contacto';
export const SHOW_ASOCIADO_CONTACTO = 'show_asociado_contacto';
export const UPDATE_ASOCIADO_CONTACTO = 'update_asociado_contacto';
export const CREATE_ASOCIADO_CONTACTO = 'create_asociado_contacto';
export const DELETE_ASOCIADO_CONTACTO = 'delete_asociado_contacto';
export const GET_COLECCION_ASOCIADO_BANCARIA =
  'get_coleccion_asociado_bancaria';
export const SHOW_ASOCIADO_BANCARIA = 'show_asociado_bancaria';
export const UPDATE_ASOCIADO_BANCARIA = 'update_asociado_bancaria';
export const CREATE_ASOCIADO_BANCARIA = 'create_asociado_bancaria';
export const DELETE_ASOCIADO_BANCARIA = 'delete_asociado_bancaria';
export const GET_COLECCION_ASOCIADO_COMERCIAL =
  'get_coleccion_asociado_comercial';
export const SHOW_ASOCIADO_COMERCIAL = 'show_asociado_comercial';
export const UPDATE_ASOCIADO_COMERCIAL = 'update_asociado_comercial';
export const CREATE_ASOCIADO_COMERCIAL = 'create_asociado_comercial';
export const DELETE_ASOCIADO_COMERCIAL = 'delete_asociado_comercial';
export const GET_COLECCION_ASOCIADO_REQUISITO_SEGURIDAD =
  'get_coleccion_asociado_requisito_seguridad';
export const SHOW_ASOCIADO_REQUISITO_SEGURIDAD =
  'show_asociado_requisito_seguridad';
export const UPDATE_ASOCIADO_REQUISITO_SEGURIDAD =
  'update_asociado_requisito_seguridad';
export const GET_COLECCION_ASOCIADO_DOCUMENTO =
  'get_coleccion_asociado_documento';
export const SHOW_ASOCIADO_DOCUMENTO = 'show_asociado_documento';
export const CREATE_ASOCIADO_DOCUMENTO = 'create_asociado_documento';
export const DELETE_ASOCIADO_DOCUMENTO = 'delete_asociado_documento';
export const GET_COLECCION_ORDEN_SERVICIO_DOCUMENTO =
  'get_coleccion_orden_servicio_documentos';
export const SHOW_ORDEN_SERVICIO_DOCUMENTO = 'show_orden_servicio_documentos';
export const CREATE_ORDEN_SERVICIO_DOCUMENTO =
  'create_orden_servicio_documentos';
export const DELETE_ORDEN_SERVICIO_DOCUMENTO =
  'delete_orden_servicio_documentos';
export const GET_COLECCION_APLICACION = 'get_coleccion_aplicacion';
export const GET_COLECCION_LIGERA_APLICACION =
  'get_coleccion_ligera_aplicacion';
export const SHOW_APLICACION = 'show_aplicacion';
export const UPDATE_APLICACION = 'update_aplicacion';
export const CREATE_APLICACION = 'create_aplicacion';
export const DELETE_APLICACION = 'delete_aplicacion';
export const GET_COLECCION_MODULO = 'get_coleccion_modulo';
export const GET_COLECCION_LIGERA_MODULO = 'get_coleccion_ligera_modulo';
export const SHOW_MODULO = 'show_modulo';
export const UPDATE_MODULO = 'update_modulo';
export const CREATE_MODULO = 'create_modulo';
export const DELETE_MODULO = 'delete_modulo';
export const GET_COLECCION_OPCION_SISTEMA = 'get_coleccion_opcion_sistema';
export const GET_COLECCION_LIGERA_OPCION_SISTEMA =
  'get_coleccion_ligera_opcion_sistema';
export const SHOW_OPCION_SISTEMA = 'show_opcion_sistema';
export const UPDATE_OPCION_SISTEMA = 'update_opcion_sistema';
export const CREATE_OPCION_SISTEMA = 'create_opcion_sistema';
export const DELETE_OPCION_SISTEMA = 'delete_opcion_sistema';
export const GET_COLECCION_PERMISO = 'get_coleccion_permiso';
export const GET_COLECCION_LIGERA_PERMISO = 'get_coleccion_ligera_permiso';
export const SHOW_PERMISO = 'show_permiso';
export const UPDATE_PERMISO = 'update_permiso';
export const CREATE_PERMISO = 'create_permiso';
export const DELETE_PERMISO = 'delete_permiso';
export const GET_COLECCION_CONSULTA_AUDITORIA =
  'get_coleccion_consulta_auditoria';
export const GET_COLECCION_SOLICITUD_COTIZACION = 'get_coleccion_permiso';
export const GET_COLECCION_LIGERA_SOLICITUD_COTIZACION =
  'get_coleccion_ligera_permiso';
export const SHOW_SOLICITUD_COTIZACION = 'show_permiso';
export const UPDATE_SOLICITUD_COTIZACION = 'update_permiso';
export const CREATE_SOLICITUD_COTIZACION = 'create_permiso';
export const DELETE_SOLICITUD_COTIZACION = 'delete_permiso';
export const GET_COLECCION_LIGERA_SOLICITUD_COTIZACION_CIUDAD =
  'get_coleccion_ligera_solicitud_cotizacion_ciudad';
export const GET_COLECCION_LIGERA_SOLICITUD_COTIZACION_SERVICIO =
  'get_coleccion_ligera_solicitud_cotizacion_servicio';
export const ACTUALIZAR_CONSECUTIVO = 'actualziar_consecutivo';
export const INFORMACION_SOLICITUD_CONTACTO = 'informacion_solicitud_contacto';
export const GET_COLECCION_RUTA = 'get_coleccion_ruta';
export const GET_COLECCION_LIGERA_RUTA = 'get_coleccion_ligera_ruta';
export const SHOW_RUTA = 'show_ruta';
export const UPDATE_RUTA = 'update_ruta';
export const CREATE_RUTA = 'create_ruta';
export const DELETE_RUTA = 'delete_ruta';
export const BUSCAR_RUTA = 'buscar_ruta';
export const CLEAN_RUTA = 'clean_ruta';
export const GET_COLECCION_TARIFA = 'get_coleccion_tarifa';
export const GET_COLECCION_LIGERA_TARIFA = 'get_coleccion_ligera_tarifa';
export const SHOW_TARIFA = 'show_tarifa';
export const UPDATE_TARIFA = 'update_tarifa';
export const CREATE_TARIFA = 'create_tarifa';
export const DELETE_TARIFA = 'delete_tarifa';
export const BUSCAR_TARIFA = 'buscar_tarifa';
export const DIAS_VIAJES = 'dias_viajes';
export const GET_COLECCION_COTIZACION = 'get_coleccion_cotizacion';
export const GET_COLECCION_LIGERA_COTIZACION =
  'get_coleccion_ligera_cotizacion';
export const SHOW_COTIZACION = 'show_cotizacion';
export const UPDATE_COTIZACION = 'update_cotizacion';
export const CREATE_COTIZACION = 'create_cotizacion';
export const DELETE_COTIZACION = 'delete_cotizacion';
export const ENVIAR_COTIZACION = 'enviar_cotizacion';
export const APPROVE_COTIZACION = 'approve_cotizacion';
export const GET_COLECCION_DETALLE_COTIZACION =
  'get_coleccion_detalle_cotizacion';
export const GET_COLECCION_LIGERA_DETALLE_COTIZACION =
  'get_coleccion_ligera_detalle_cotizacion';
export const SHOW_DETALLE_COTIZACION = 'show_detalle_cotizacion';
export const UPDATE_DETALLE_COTIZACION = 'update_detalle_cotizacion';
export const CREATE_DETALLE_COTIZACION = 'create_detalle_cotizacion';
export const DELETE_DETALLE_COTIZACION = 'delete_detalle_cotizacion';
export const GET_COLECCION_LUGAR = 'get_coleccion_lugar';
export const GET_COLECCION_LIGERA_LUGAR = 'get_coleccion_ligera_lugar';
export const SHOW_LUGAR = 'show_lugar';
export const UPDATE_LUGAR = 'update_lugar';
export const CREATE_LUGAR = 'create_lugar';
export const DELETE_LUGAR = 'delete_lugar';
export const GET_COLECCION_ACUERDO_SERVICIO = 'get_coleccion_acuerdo_servicio';
export const GET_COLECCION_LIGERA_ACUERDO_SERVICIO =
  'get_coleccion_ligera_acuerdo_servicio';
export const SHOW_ACUERDO_SERVICIO = 'show_acuerdo_servicio';
export const UPDATE_ACUERDO_SERVICIO = 'update_acuerdo_servicio';
export const CREATE_ACUERDO_SERVICIO = 'create_acuerdo_servicio';
export const DELETE_ACUERDO_SERVICIO = 'delete_acuerdo_servicio';
export const APPROVE_ACUERDO_SERVICIO = 'approve_acuerdo_servicio';
export const GET_COLECCION_NOTIFICACION_CONTACTO =
  'get_coleccion_notificacion_contacto';
export const GET_COLECCION_LIGERA_NOTIFICACION_CONTACTO =
  'get_coleccion_ligera_notificacion_contacto';
export const SHOW_NOTIFICACION_CONTACTO = 'show_notificacion_contacto';
export const UPDATE_NOTIFICACION_CONTACTO = 'update_notificacion_contacto';
export const CREATE_NOTIFICACION_CONTACTO = 'create_notificacion_contacto';
export const DELETE_NOTIFICACION_CONTACTO = 'delete_notificacion_contacto';
export const GET_COLECCION_RUTA_AUTORIZACION =
  'get_coleccion_ruta_autorizacion';
export const GET_COLECCION_LIGERA_RUTA_AUTORIZACION =
  'get_coleccion_ligera_ruta_autorizacion';
export const SHOW_RUTA_AUTORIZACION = 'show_ruta_autorizacion';
export const UPDATE_RUTA_AUTORIZACION = 'update_ruta_autorizacion';
export const CREATE_RUTA_AUTORIZACION = 'create_ruta_autorizacion';
export const DELETE_RUTA_AUTORIZACION = 'delete_ruta_autorizacion';
export const GET_COLECCION_PUESTO_PARADA = 'get_coleccion_puesto_parada';
export const GET_COLECCION_LIGERA_PUESTO_PARADA =
  'get_coleccion_ligera_puesto_parada';
export const SHOW_PUESTO_PARADA = 'show_puesto_parada';
export const UPDATE_PUESTO_PARADA = 'update_puesto_parada';
export const CREATE_PUESTO_PARADA = 'create_puesto_parada';
export const DELETE_PUESTO_PARADA = 'delete_puesto_parada';
export const GET_COLECCION_RUTA_CONTROL = 'get_coleccion_ruta_control';
export const GET_COLECCION_LIGERA_RUTA_CONTROL =
  'get_coleccion_ligera_ruta_control';
export const SHOW_RUTA_CONTROL = 'show_ruta_control';
export const UPDATE_RUTA_CONTROL = 'update_ruta_control';
export const CREATE_RUTA_CONTROL = 'create_ruta_control';
export const DELETE_RUTA_CONTROL = 'delete_ruta_control';
export const GET_COLECCION_PUESTO_CONTROL = 'get_coleccion_puesto_control';
export const GET_COLECCION_LIGERA_PUESTO_CONTROL =
  'get_coleccion_ligera_puesto_control';
export const SHOW_PUESTO_CONTROL = 'show_puesto_control';
export const UPDATE_PUESTO_CONTROL = 'update_puesto_control';
export const CREATE_PUESTO_CONTROL = 'create_puesto_control';
export const DELETE_PUESTO_CONTROL = 'delete_puesto_control';
export const GET_COLECCION_ESTADO_EQUIPO = 'get_coleccion_estado_equipo';
export const GET_COLECCION_LIGERA_ESTADO_EQUIPO =
  'get_coleccion_ligera_estado_equipo';
export const SHOW_ESTADO_EQUIPO = 'show_estado_equipo';
export const UPDATE_ESTADO_EQUIPO = 'update_estado_equipo';
export const CREATE_ESTADO_EQUIPO = 'create_estado_equipo';
export const DELETE_ESTADO_EQUIPO = 'delete_estado_equipo';
export const GET_COLECCION_EVENTO_BITACORA_EQUIPO =
  'get_coleccion_evento_bitacora_equipo';
export const GET_COLECCION_LIGERA_EVENTO_BITACORA_EQUIPO =
  'get_coleccion_ligera_evento_bitacora_equipo';
export const SHOW_EVENTO_BITACORA_EQUIPO = 'show_evento_bitacora_equipo';
export const UPDATE_EVENTO_BITACORA_EQUIPO = 'update_evento_bitacora_equipo';
export const CREATE_EVENTO_BITACORA_EQUIPO = 'create_evento_bitacora_equipo';
export const DELETE_EVENTO_BITACORA_EQUIPO = 'delete_evento_bitacora_equipo';
export const GET_COLECCION_ORDEN_SERVICIO = 'get_coleccion_orden_servicio';
export const GET_COLECCION_LIGERA_ORDEN_SERVICIO =
  'get_coleccion_ligera_orden_servicio';
export const SHOW_ORDEN_SERVICIO = 'show_orden_servicio';
export const UPDATE_ORDEN_SERVICIO = 'update_orden_servicio';
export const DELETE_ORDEN_SERVICIO = 'delete_orden_servicio';
export const CREATE_ORDEN_SERVICIO = 'create_orden_servicio';
export const APPROVE_ORDEN_SERVICIO = 'approve_orden_servicio';
export const GET_COLECCION_LIGERA_ASOCIADO_ORDEN =
  'get_coleccion_ligera_asociado_orden';
export const GET_COLECCION_LIGERA_SERVICIOS_ORDEN =
  'get_coleccion_ligera_servicios_orden';
export const GET_COLECCION_LIGERA_TERCERO_SERVICIO_ORDEN =
  'get_coleccion_ligera_tercero_servicio_orden';
export const GET_ORDEN_SERVICIO_RUTAS = 'get_orden_servicio_rutas';
export const GET_ORDEN_SERVICIO_PROGRAMACION =
  'get_orden_servicio_programacion';
export const ENVIAR_PROGRAMACION = 'enviar_programacion';
export const GET_COLECCION_INFORMACION_EQUIPO =
  'get_coleccion_informacion_equipo';
export const GET_COLECCION_LIGERA_INFORMACION_EQUIPO =
  'get_coleccion_ligera_informacion_equipo';
export const SHOW_INFORMACION_EQUIPO = 'show_informacion_equipo';
export const UPDATE_INFORMACION_EQUIPO = 'update_informacion_equipo';
export const DELETE_INFORMACION_EQUIPO = 'delete_informacion_equipo';
export const CREATE_INFORMACION_EQUIPO = 'create_informacion_equipo';
export const GET_COLECCION_PRODUCTO = 'get_coleccion_producto';
export const GET_COLECCION_LIGERA_PRODUCTO = 'get_coleccion_ligera_producto';
export const SHOW_PRODUCTO = 'show_producto';
export const UPDATE_PRODUCTO = 'update_producto';
export const DELETE_PRODUCTO = 'delete_producto';
export const CREATE_PRODUCTO = 'create_producto';
export const GET_COLECCION_PEDIDO = 'get_coleccion_pedido';
export const GET_COLECCION_LIGERA_PEDIDO = 'get_coleccion_ligera_pedido';
export const SHOW_PEDIDO = 'show_pedido';
export const UPDATE_PEDIDO = 'update_pedido';
export const CREATE_PEDIDO = 'create_pedido';
export const DELETE_PEDIDO = 'delete_pedido';
export const GET_COLECCION_DETALLE_PEDIDO = 'get_coleccion_detalle_pedido';
export const GET_COLECCION_LIGERA_DETALLE_PEDIDO =
  'get_coleccion_ligera_detalle_pedido';
export const SHOW_DETALLE_PEDIDO = 'show_detalle_pedido';
export const UPDATE_DETALLE_PEDIDO = 'update_detalle_pedido';
export const CREATE_DETALLE_PEDIDO = 'create_detalle_pedido';
export const DELETE_DETALLE_PEDIDO = 'delete_detalle_pedido';
export const GET_COLECCION_TIPO_PRODUCTO = 'get_coleccion_tipo_producto';
export const GET_COLECCION_LIGERA_TIPO_PRODUCTO =
  'get_coleccion_ligera_tipo_producto';
export const SHOW_TIPO_PRODUCTO = 'show_tipo_producto';
export const UPDATE_TIPO_PRODUCTO = 'update_tipo_producto';
export const CREATE_TIPO_PRODUCTO = 'create_tipo_producto';
export const DELETE_TIPO_PRODUCTO = 'delete_tipo_producto';
export const GET_COLECCION_COLOR = 'get_coleccion_color';
export const GET_COLECCION_LIGERA_COLOR = 'get_coleccion_ligera_color';
export const SHOW_COLOR = 'show_color';
export const UPDATE_COLOR = 'update_color';
export const CREATE_COLOR = 'create_color';
export const DELETE_COLOR = 'delete_color';
export const GET_COLECCION_RECURSO_TECNICO = 'get_coleccion_recurso_tecnico';
export const GET_COLECCION_LIGERA_RECURSO_TECNICO =
  'get_coleccion_ligera_recurso_tecnico';
export const SHOW_RECURSO_TECNICO = 'show_recurso_tecnico';
export const UPDATE_RECURSO_TECNICO = 'update_recurso_tecnico';
export const CREATE_RECURSO_TECNICO = 'create_recurso_tecnico';
export const DELETE_RECURSO_TECNICO = 'delete_recurso_tecnico';
export const GET_COLECCION_HORARIO_RECURSO_TECNICO =
  'get_coleccion_horario_recurso_tecnico';
export const GET_COLECCION_CONSULTA_HORAS_TECNICO =
  'get_coleccion_consulta_horas_tecnico';
export const GET_COLECCION_LIGERA_HORARIO_RECURSO_TECNICO =
  'get_coleccion_ligera_horario_recurso_tecnico';
export const SHOW_HORARIO_RECURSO_TECNICO = 'show_horario_recurso_tecnico';
export const SHOW_HORARIO_CONSULTA_RECURSO_TECNICO =
  'show_horario_consulta_recurso_tecnico';
export const UPDATE_HORARIO_RECURSO_TECNICO = 'update_horario_recurso_tecnico';
export const CREATE_HORARIO_RECURSO_TECNICO = 'create_horario_recurso_tecnico';
export const DELETE_HORARIO_RECURSO_TECNICO = 'delete_horario_recurso_tecnico';
export const CONSULTAR_FECHAS = 'consultar_fechas';
export const PROGRAMAR_HORARIOS = 'programar_horarios';
export const GET_COLECCION_SOLICITUD_COTIZACION_PRODUCTO =
  'get_coleccion_solicitud_cotizacion_producto';
export const GET_COLECCION_LIGERA_SOLICITUD_COTIZACION_PRODUCTO =
  'get_coleccion_ligera_solicitud_cotizacion_producto';
export const SHOW_SOLICITUD_COTIZACION_PRODUCTO =
  'show_solicitud_cotizacion_producto';
export const UPDATE_SOLICITUD_COTIZACION_PRODUCTO =
  'update_solicitud_cotizacion_producto';
export const CREATE_SOLICITUD_COTIZACION_PRODUCTO =
  'create_solicitud_cotizacion_producto';
export const DELETE_SOLICITUD_COTIZACION_PRODUCTO =
  'delete_solicitud_cotizacion_producto';
export const INFORMACION_SOLICITUD_COTIZACION_PRODUCTO_CONTACTO =
  'informacion_solicitud_contacto';
export const GET_COLECCION_DETALLE_SOLICITUD_COTIZACION_PRODUCTO =
  'get_coleccion_detalle_solicitud_cotizacion_producto';
export const GET_COLECCION_LIGERA_DETALLE_SOLICITUD_COTIZACION_PRODUCTO =
  'get_coleccion_ligera_detalle_solicitud_cotizacion_producto';
export const SHOW_DETALLE_SOLICITUD_COTIZACION_PRODUCTO =
  'show_detalle_solicitud_cotizacion_producto';
export const UPDATE_DETALLE_SOLICITUD_COTIZACION_PRODUCTO =
  'update_detalle_solicitud_cotizacion_producto';
export const CREATE_DETALLE_SOLICITUD_COTIZACION_PRODUCTO =
  'create_detalle_solicitud_cotizacion_producto';
export const DELETE_DETALLE_SOLICITUD_COTIZACION_PRODUCTO =
  'delete_detalle_solicitud_cotizacion_producto';
export const GET_COLECCION_COTIZACION_PRODUCTO =
  'get_coleccion_cotizacion_producto';
export const GET_COLECCION_LIGERA_COTIZACION_PRODUCTO =
  'get_coleccion_ligera_cotizacion_producto';
export const SHOW_COTIZACION_PRODUCTO = 'show_cotizacion_producto';
export const UPDATE_COTIZACION_PRODUCTO = 'update_cotizacion_producto';
export const CREATE_COTIZACION_PRODUCTO = 'create_cotizacion_producto';
export const DELETE_COTIZACION_PRODUCTO = 'delete_cotizacion_producto';
export const ENVIAR_COTIZACION_PRODUCTO = 'enviar_cotizacion_producto';
export const APPROVE_COTIZACION_PRODUCTO = 'approve_cotizacion_producto';
export const GET_COLECCION_DETALLE_COTIZACION_PRODUCTO =
  'get_coleccion_detalle_cotizacion_producto';
export const GET_COLECCION_LIGERA_DETALLE_COTIZACION_PRODUCTO =
  'get_coleccion_ligera_detalle_cotizacion_producto';
export const SHOW_DETALLE_COTIZACION_PRODUCTO =
  'show_detalle_cotizacion_producto';
export const UPDATE_DETALLE_COTIZACION_PRODUCTO =
  'update_detalle_cotizacion_producto';
export const CREATE_DETALLE_COTIZACION_PRODUCTO =
  'create_detalle_cotizacion_producto';
export const DELETE_DETALLE_COTIZACION_PRODUCTO =
  'delete_detalle_cotizacion_producto';
export const GET_COLECCION_BITACORA_EQUIPO = 'get_coleccion_bitacora_equipo';
export const GET_COLECCION_LIGERA_BITACORA_EQUIPO =
  'get_coleccion_ligera_bitacora_equipo';
export const SHOW_BITACORA_EQUIPO = 'show_bitacora_equipo';
export const UPDATE_BITACORA_EQUIPO = 'update_bitacora_equipo';
export const CREATE_BITACORA_EQUIPO = 'create_bitacora_equipo';
export const DELETE_BITACORA_EQUIPO = 'delete_bitacora_equipo';
export const GET_COLECCION_FACTURAR_SERVICIO_TERMINADO =
  'get_coleccion_facturar_servicio_terminado';
export const GET_COLECCION_LIGERA_FACTURAR_SERVICIO_TERMINADO =
  'get_coleccion_ligera_facturar_servicio_terminado';
export const SHOW_FACTURAR_SERVICIO_TERMINADO =
  'show_facturar_servicio_terminado';
export const GET_COLECCION_FACTURAR_CLIENTE_TERMINADO =
  'get_coleccion_facturar_cliente_terminado';
export const GET_COLECCION_LIGERA_FACTURAR_CLIENTE_TERMINADO =
  'get_coleccion_ligera_facturar_cliente_terminado';
export const SHOW_FACTURAR_CLIENTE_TERMINADO =
  'show_facturar_cliente_terminado';
//APP SETTING

export const TOGGLE_NAV_COLLAPSED = 'toggle_nav_collapsed';
export const SET_INITIAL_PATH = 'set_initial_path';

//AUTH0
export const UPDATE_AUTH_USER = 'update_auth_user';
export const SET_AUTH_TOKEN = 'set_auth_token';
export const SIGNOUT_AUTH_SUCCESS = 'signout_auth_success';

//ANALYTICS-DASHBOARD
export const GET_ANALYTICS_DATA = 'get_analytics_data';

//ECOMMERCE-DASHBOARD
export const GET_ECOMMERCE_DATA = 'get_ecommerce_data';

//ACADEMY-DASHBOARD
export const GET_ACADEMY_DATA = 'get_academy_data';

//CRM-DASHBOARD
export const GET_CRM_DATA = 'get_crm_data';

//CRYPTO-DASHBOARD
export const GET_CRYPTO_DATA = 'get_crypto_data';

//CRYPTO-DASHBOARD
export const GET_HC_DATA = 'get_hc_data';

//METRICS-DASHBOARD
export const GET_METRICS_DATA = 'get_metrics_data';

//WIDGETS_DASHBOARD
export const GET_WIDGETS_DATA = 'get_widgets_data';

//MAIL-APP
export const GET_MAIL_LIST = 'get_mail_list';
export const GET_FOLDER_LIST = 'get_folder_list';
export const GET_LABEL_LIST = 'get_label_list';
export const TOGGLE_MAIL_DRAWER = 'toggle_mail_drawer';
export const COMPOSE_MAIL = 'compose_mail';
export const GET_MAIL_DETAIL = 'get_mail_detail';
export const UPDATE_MAIL_FOLDER = 'update_mail_folders';
export const UPDATE_MAIL_LABEL = 'update_mail_label';
export const UPDATE_STARRED_STATUS = 'update_starred_status';
export const UPDATED_MAIL_DETAIL = 'updated_mail_detail';
export const CHANGE_READ_STATUS = 'change_read_status';
export const GET_CONNECTION_LIST = 'get_connection_list';
export const NULLIFY_MAIL = 'nullify_mail';

//TODO-APP
export const GET_TASK_LIST = 'get_task_list';
export const CREATE_NEW_TASK = 'create_new_task';
export const TOGGLE_TODO_DRAWER = 'toggle_todo_drawer';
export const GET_TODO_FOLDER_LIST = 'GET_TODO_FOLDER_LIST';
export const GET_TODO_LABEL_LIST = 'GET_TODO_LABEL_LIST';
export const GET_TODO_STATUS_LIST = 'GET_TODO_STATUS_LIST';
export const GET_TODO_PRIORITY_LIST = 'GET_TODO_PRIORITY_LIST';
export const UPDATE_TASK_FOLDER = 'UPDATE_TASK_FOLDER';
export const UPDATE_TASK_LABEL = 'UPDATE_TASK_LABEL';
export const UPDATE_TASK_STARRED_STATUS = 'UPDATE_TASK_STARRED_STATUS';
export const GET_TASK_DETAIL = 'GET_TASK_DETAIL';
export const UPDATE_TASK_DETAIL = 'UPDATE_TASK_DETAIL';
export const GET_TODO_STAFF_LIST = 'GET_TODO_STAFF_LIST';

//CONTACT_APP
export const GET_CONTACT_LIST = 'GET_CONTACT_LIST';
export const GET_CONTACT_FOLDER_LIST = 'GET_CONTACT_FOLDER_LIST';
export const GET_CONTACT_LABEL_LIST = 'GET_CONTACT_LABEL_LIST';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const UPDATE_CONTACT_LABEL = 'UPDATE_CONTACT_LABEL';
export const UPDATE_CONTACT_STARRED_STATUS = 'UPDATE_CONTACT_STARRED_STATUS';
export const GET_CONTACT_DETAIL = 'GET_CONTACT_DETAIL';
export const TOGGLE_CONTACT_DRAWER = 'TOGGLE_CONTACT_DRAWER';
export const UPDATE_CONTACT_DETAIL = 'UPDATE_CONTACT_DETAIL';
export const CREATE_NEW_CONTACT = 'CREATE_NEW_CONTACT';

//SCRUMBOARD_APP
export const GET_MEMBER_LIST = 'GET_MEMBER_LIST';
export const GET_SCRUM_LABEL_LIST = 'GET_SCRUM_LABEL_LIST';
export const GET_BOARDS = 'GET_BOARDS';
export const GET_BOARD_DETAIL = 'GET_BOARD_DETAIL';
export const ADD_BOARD_LIST = 'ADD_BOARD_LIST';
export const ADD_LIST_CARD = 'ADD_LIST_CARD';
export const EDIT_LIST_CARD = 'EDIT_LIST_CARD';
export const DELETE_LIST_CARD = 'DELETE_LIST_CARD';
export const DELETE_BOARD = 'DELETE_BOARD';
export const ADD_NEW_BOARD = 'ADD_NEW_BOARD';
export const DELETE_LIST = 'DELETE_LIST';
export const EDIT_BOARD_DETAIL = 'EDIT_BOARD_DETAIL';
export const EDIT_BOARD_LIST = 'EDIT_BOARD_LIST';

//CHAT_APP
export const GET_CONNECTIONS_LIST = 'get_connections_list';
export const GET_USER_MESSAGES = 'get_user_messages';
export const ADD_NEW_MESSAGE = 'add_new_message';
export const EDIT_MESSAGE = 'edit_message';
export const DELETE_MESSAGE = 'delete_message';
export const DELETE_USER_MESSAGES = 'delete_user_messages';
export const TOGGLE_CHAT_DRAWER = 'toggle_chat_drawer';
export const SELECT_USER = 'select_user';

//WALL_APP
export const GET_WALL_DATA = 'get_wall_data';
export const GET_FEED_POSTS = 'get_feed_posts';
export const CREATE_NEW_POST = 'create_new_post';
export const UPDATE_POST = 'update_post';

//USER_LIST
export const GET_USER_LIST = 'GET_USER_LIST';

//ECOMMERCE_LIST
export const GET_ECOMMERCE_LIST = 'get_ecommerce_list';
export const SET_PRODUCT_VIEW_TYPE = 'set_product_view_type';
export const SET_FILTER_DATA = 'set_filter_data';
export const SET_PRODUCT_DATA = 'set_product_data';
export const GET_RECENT_ORDER = 'get_recent_order';
export const GET_CUSTOMERS = 'get_customers';
export const ADD_CART_ITEM = 'add_cart_item';
export const REMOVE_CART_ITEM = 'remove_cart_item';
export const UPDATE_CART_ITEM = 'update_cart_item';
export const SET_CART_ITEMS = 'set_cart_items';

//CK-EDITOR
export const GET_BALLOON_BLOCK_DATA = 'get_balloon_block_data';
export const UPDATE_BALLOON_BLOCK_DATA = 'update_balloon_block_data';
export const GET_BALLOON_DATA = 'get_balloon_data';
export const UPDATE_BALLOON_DATA = 'update_balloon_data';
export const GET_CLASSIC_DATA = 'get_classic_data';
export const UPDATE_CLASSIC_DATA = 'update_classic_data';
export const GET_INLINE_DATA = 'get_inline_data';
export const UPDATE_INLINE_DATA = 'update_inline_data';
export const GET_DOCUMENT_DATA = 'get_document_data';
export const UPDATE_DOCUMENT_DATA = 'update_document_data';
export const GET_CUSTOM_DATA = 'get_custom_data';
export const UPDATE_CUSTOM_DATA = 'update_custom_data';

//GALLERY
export const GET_GALLERY_PHOTO = 'get_gallery_photo';
